module.exports = __webpack_public_path__ + "static/media/Logipool-Banner-logo.ea8452cc.png";